module.exports = __webpack_public_path__ + "img/carrot-black.ee2976f0.svg";